import { NgModule } from '@angular/core';
import { DataConnectModule } from '@epicuro-next/data/connect';
import { SignalRModule } from '@epicuro-next/data/signalr';
import { StorageModule } from '@epicuro-next/platform/storage';
import { AccountsStateModule } from '@epicuro-next/state/accounts-state';
import { ConnectTokenStateModule } from '@epicuro-next/state/connect-token-state';
import { SignalrStateModule } from '@epicuro-next/state/signalr-state';
import { StateSitesStateModule } from '@epicuro-next/state/site-state';
import { UserStateModule } from '@epicuro-next/state/user-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  ConnectCallEffects,
  ConnectEffects,
  ConnectNotificationEffects,
  ConnectSignalrEffects,
  ConnectTwilioEffects,
} from './state/effects';
import { connectFeatureKey, initialState, reducers } from './state/store';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(connectFeatureKey, reducers, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
    EffectsModule.forFeature([
      ConnectEffects,
      ConnectSignalrEffects,
      ConnectTwilioEffects,
      ConnectCallEffects,
      ConnectNotificationEffects,
    ]),
    StorageModule,
    DataConnectModule,
    SignalRModule,
    UserStateModule,
    AccountsStateModule,
    StateSitesStateModule,
    ConnectTokenStateModule,
    SignalrStateModule,
  ],
})
export class ConnectStateModule {}
